import {Injectable} from '@angular/core';
import {ContentService} from '@common/services/content.service';
import {CommunityService} from '@common/services/community.service';
import {Observable} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';

@Injectable()
export class ContentHelperService {
    constructor(
        private contentService: ContentService,
        private communityService: CommunityService,
    ) { }

    public getFullKeyNameIfExists(baseKey: string): Observable<string> {
        return this.communityService.currentAuctionOpenForNewRegistrations$.pipe(
            switchMap(isOpen => {
                const key = `${isOpen ? '' : 'interested-individual-'}${baseKey}`;
                return this.contentService.valueExists(key).pipe(
                    map(exists => exists ? key : baseKey)
                );
            }),
            switchMap(fullKey => {
                return this.contentService.valueExists(fullKey).pipe(
                    map(exists => exists ? fullKey : '')
                );
            }),
        );
    }
}
